const MAX_ARTIFACTS = 100

export default {
  toggleAutoBCC(state) {
    state.autoBCC = !state.autoBCC
  },
  toggleRunning(state) {
    state.running = !state.running
  },
  setUser(state, data) {
    state.userEmail = data.userEmail
    state.userName = data.userName
    state.userAgentToken = data.userAgentToken
  },
  logout(state) {
    state.userEmail = null
    state.userName = null
    state.userAgentToken = null
  },
  addArtifacts(state, artifacts) {
    if (state.artifacts.length < MAX_ARTIFACTS) state.artifacts.push(artifacts)
    else console.log('maximum artifacts limit reached')
  },
  setArtifacts(state, artifacts) {
    state.artifacts = artifacts
  },
  clearArtifacts(state) {
    state.artifacts = []
  },
  pingActivity(state) {
    var dateObj = new Date()
    let hour = dateObj.getHours()
    state.activity[hour]++
  },
  setActivityDate(state) {
    var dateObj = new Date()
    let today = dateObj.getDate()
    if (state.activityDate !== today) {
      // reset the activity to blank
      console.log('resetting activity data')
      state.activity = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
    state.activityDate = today
  },
  toggleDevMode(state) {
    state.devMode = !state.devMode
  },
  updateDevServer(state, server) {
    state.devServer = server
  },
  setBccEmails(state, emails) {
    state.bccEmails = emails
  },
  setBccWhenRecipientInEmails(state, emails) {
    state.bccWhenRecipientInEmails = emails
  },
  setDontBccWhenRecipientInEmails(state, emails) {
    state.dontBccWhenRecipientInEmails = emails
  },
  toggleSubjectOptimize(state) {
    state.subjectOptimize = !state.subjectOptimize
  },
}
